import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyPromise } from '../../interceptors/myPromise.service';

const PROCEDURES_API = `${environment.baseEndpoint}/procedures`;

@Injectable({
  providedIn: 'root',
})
export class ProcedureThirteenService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }

  getSimulacrumProgram(stationId) {
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/13/simulacrumProgram`));
  }

  simulacrumProgram(stationId, simulacrumProgram) {
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/13/simulacrumProgram`, simulacrumProgram));
  }
}
